export default class Favorites {
	constructor ($trigger, $allTriggers) {
		this.$trigger = $trigger;
		this.$card = null;
		if (!$trigger.data('ajax-type')) {
			this.route = window.projectConfig.route.ajax.favorites.default;
		} else {
			this.route = window.projectConfig.route.ajax.favorites.projects;
		}
		this.type = $trigger.data('favorites-type') || 'trigger-only';
		this.id = $trigger.data('complex-id') || null;
		this.$sameTriggers = $allTriggers.not(this.$trigger).filter(`[data-complex-id="${this.id}"]`);
		this.$favoritesBlock = $('[data-favorites-count]');

		if (this.type === 'card') {
			this.$card = this.$trigger.closest('[data-favorites-card]');
		}

		this.updateTriggers();
		this.addListeners();
	}

	updateTriggers () {
		let titles = this.$trigger.data('favorites-titles');

		if (this.$trigger.hasClass('is-in-favorites')) {
			this.$sameTriggers.add(this.$trigger).addClass('is-active').attr('title', titles[1]).find('.button__text').text(titles[1]);
		} else {
			this.$sameTriggers.add(this.$trigger).removeClass('is-active').attr('title', titles[0]).find('.button__text').text(titles[0]);
		}
	}

	addListeners () {
		this.$trigger.on('click', () => {
			this.$trigger.addClass('pending');
			let favoritesCount = this.$favoritesBlock.attr('data-favorites-count');
			let isInFavorites = this.$trigger.hasClass('is-in-favorites');

			if (/^card$/i.test(this.type) && this.$trigger.hasClass('is-in-favorites')) {
				this.confirm()
					.then((choice) => {
						if (choice === 'remove') {
							this.$favoritesBlock.attr('data-favorites-count', --favoritesCount);
							if (favoritesCount === 0) {
								this.$favoritesBlock.removeClass('has-favorites');
							}
							this.request();
						} else if (choice === 'cancel') {
							this.clearInteractive();
							// perhaps some kind of logic, if the removal from the favorites was canceled
						}
					})
					.catch((err) => {
						console.error(err);
						this.clearInteractive();
					});
			} else {
				if (isInFavorites) {
					this.$favoritesBlock.attr('data-favorites-count', --favoritesCount);

					if (favoritesCount === 0) {
						this.$favoritesBlock.removeClass('has-favorites');
					}
				} else {
					this.$favoritesBlock.addClass('has-favorites');
					this.$favoritesBlock.attr('data-favorites-count', ++favoritesCount);
				}
				this.request();
			}
		});
	}

	request () {
		let _self = this;

		return $.ajax({
			url: this.route,
			method: 'POST',
			data: {
				id: this.id
			}
		})
			.done((response) => {
				_self.requestCallback(response);
				_self.clearInteractive(response);
			})
			.fail((err) => {
				console.warn(err);
				_self.clearInteractive();
				window.Noty.error('Script error');
			})
			.always((response) => {
				Favorites.updateSummary(response);
			});
	}

	requestCallback (response) {
		if (response.success) {
			if (response.action === 'add') {
				this.$trigger.addClass('is-in-favorites');
			} else if (response.action === 'remove') {
				this.$trigger.removeClass('is-in-favorites');

				if (this.type === 'card' && /favorites/gi.test(window.location.pathname)) {
					let $rootCell = this.$card.closest('.gcell');
					let reload = $rootCell.siblings('.gcell').length === 0;
					this.$card.fadeOut(300, () => {
						$rootCell.remove();
						if (reload) {
							window.location.reload();
						}
					});
				}
			}

			this.updateTriggers();

			if (response.message) {
				window.Noty.success(response.message);
			}
		}

		if (!response.success) {
			if (response.message) {
				window.Noty.error(response.message);
			}
		}
	}

	clearInteractive () {
		this.$trigger.removeClass('pending');
	}

	confirm () {
		this.$card.addClass('confirm-is-open');
		return new Promise((resolve, reject) => {
			this.$card.find('[data-confirm-action]').one('click.confirm', (e) => {
				let choice = $(e.currentTarget).data('confirm-action').toLocaleLowerCase();
				this.$card.removeClass('confirm-is-open');
				if (!/^remove$|^cancel$/i.test(choice)) {
					reject(new Error(`\nSomething went wrong.\nChoice [remove] or [cancel] expected\nBut choice [${choice}] was received\n----------------------`));
				}
				resolve(choice);
			});
		});
	}

	static updateSummary (oInfo = null) {
		if (!oInfo) {
			return;
		}

		let $tooltip = $('[data-favorites-tooltip]');
		let $tooltipText = $tooltip.find('[data-tooltip-text]');
		let $favoritesCount = $('[data-favorites-count]');

		let totalCount = oInfo.count;
		let tooltipText = `${oInfo.count}&nbsp;${oInfo.text}`;

		if (totalCount > 0) {
			$favoritesCount.addClass('has-favorites');
			$tooltip.addClass('has-tooltip');
		} else {
			$favoritesCount.removeClass('has-favorites');
			$tooltip.removeClass('has-tooltip');
		}

		$favoritesCount.attr('data-favorites-count', totalCount);
		$tooltipText.html(tooltipText);
	}
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_classes/Favorites.js